import React from "react";
import { Helmet } from "react-helmet";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CategoriesList from "../components/CategoriesList";
import { endOfTitle } from "../../../constants/constants";
import { SERVICE_CATEGORY_LIST } from "../constants";

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: "2rem",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  subjectsListContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
}));

const CategoriesPage = () => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Services{endOfTitle}</title>
      </Helmet>
      <Container maxWidth="lg">
        <h1 className={classes.header}>Services</h1>
        <CategoriesList categoriesList={SERVICE_CATEGORY_LIST} />
      </Container>
    </>
  );
};

export default React.memo(CategoriesPage);
